import { Link } from "react-router-dom";
import { useApp } from "../../context/AppContext";
import SEO from "../../components/SEO";

export default function NotFound() {
  const { t } = useApp();
  return (
    <div className="container-ssf flex min-h-[60vh] flex-col items-start justify-center py-24" data-testid="not-found">
      <SEO title={t("not_found")} />
      <p className="font-display text-8xl font-black text-saffron-500/30">404</p>
      <h1 className="mt-2 font-display text-3xl font-bold text-navy">{t("not_found")}</h1>
      <p className="mt-3 text-slate-600">{t("not_found_sub")}</p>
      <Link to="/" className="btn-primary mt-8" data-testid="notfound-home">{t("back_home")}</Link>
    </div>
  );
}
